import { Button, Col, Divider, Form, message, Modal, Row, Tag, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import SeletedLineItem from '../../components/EOL-Checker/EOLC-Dashbard/SeletedLineItem';
import SelectModal from '../../components/EOL-Checker/EOLC-Dashbard/SelectModal';
import ResultTodayCounts from '../../components/EOL-Checker/EOLC-Dashbard/ResultTodayCounts';
import ImageContainer from '../../components/EOL-Checker/EOLC-Dashbard/ImageContainer';
import SelectPrototype from '../../components/EOL-Checker/EOLC-Dashbard/SelectPrototype';
import ReviewButton from '../../components/EOL-Checker/EOLC-Dashbard/ReviewButton';
import DispatchCheckerService from '../../services/Dispatch-Checker/DispatchCheckerService';
import { Trash2 } from "lucide-react";

const EOLC_DashbordPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [prototypeForm] = Form.useForm();
  const [selectedValue, setSelectedValue] = useState(null);
  const [getTodayCount, setGetTodayCount] = useState([]);
  const [eolData, setEolData] = useState({});
  const [prototypeValues, setPrototypeValues] = useState({ quantity: 1 });
  const [displayedDataList, setDisplayedDataList] = useState([]);
  const [hasSaved, setHasSaved] = useState(false);
  const [imageType, setImageType] = useState('Front');
  const [isPartFilled, setIsPartFilled] = useState(false);
  const [isFormFullyComplete, setIsFormFullyComplete] = useState(false);

  const userData = JSON.parse(localStorage.getItem('userData'));

  useEffect(() => {
    const fetchData = async () => {
      const response = await DispatchCheckerService.get_counts_v2(null, null); 
      setGetTodayCount(response?.today_data || {});
    };
    fetchData();
  }, []);

  const refreshCounts = async () => {
    const response = await DispatchCheckerService.get_counts_v2(selectedValue?.item, selectedValue?.line);
    setGetTodayCount(response?.today_data || {});
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  
  const handleOk = async () => {
  try {
    const values = await form.validateFields();
    setSelectedValue(values);
    setIsModalOpen(false);

    // Store selected line in localStorage
    localStorage.setItem('selectedLine', JSON.stringify({ line: values.line }));

    const response = await DispatchCheckerService.prepare_eol_screen(values.item);
    console.log("prepare_eol_screen response:", response?.data);
    if (response?.data) {
      setEolData(response.data);
    } else {
      message.info("No data found");
    }

    const response_Counts = await DispatchCheckerService.get_counts_v2(values.item, values.line);
    setGetTodayCount(response_Counts?.today_data || {});

    prototypeForm.resetFields();
    setPrototypeValues({ quantity: prototypeForm.getFieldValue('quantity') || 1 });
    setHasSaved(false);
    setDisplayedDataList([]);
    setIsPartFilled(false);
    setIsFormFullyComplete(false);
  } catch (error) {
    console.error("Error in handleOk:", error);
    message.error("Failed to load data.");
  }
};

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handlePrototypeChange = (changedValues, allValues) => {
    console.log("prototypeForm changed:", changedValues, allValues);
    setPrototypeValues(allValues);
    setIsPartFilled(!!allValues.part);
    setIsFormFullyComplete(!!allValues.part && !!allValues.defect);
  };

  const handleImageTypeChange = (newImageType) => {
    console.log("Image type changed to:", newImageType);
    setImageType(newImageType);
  };

  const handleSave = (values) => {
    const { part, defect, quantity } = values;
    const partName = eolData.parts.find(p => p.part_id === part)?.part_name || part;
    const defectName = eolData.defects.find(d => d.def_id === defect)?.def_name || defect;

    const newDisplayedData = {
      part,
      partName,
      defect,
      defectName,
      nos: quantity,
      line: selectedValue?.line,
      item: selectedValue?.item,
      userId: userData?.data?.su_id,
      imageType,
    };
    console.log("handleSave - Adding to displayedDataList:", newDisplayedData);
    setDisplayedDataList(prev => [...prev, newDisplayedData]);
    setHasSaved(true);
  };

  const handleReviewAction = (actionType) => {
    if (actionType === 'fail' || actionType === 'reject') {
      const currentQuantity = prototypeValues.quantity || 1;
      setDisplayedDataList([]);
      prototypeForm.resetFields(['part', 'defect']); // Reset part and defect
      prototypeForm.setFieldsValue({ quantity: currentQuantity });
      setPrototypeValues({ ...prototypeValues, quantity: currentQuantity });
      setHasSaved(false);
      setIsPartFilled(false);
      setIsFormFullyComplete(false);
    } else if (actionType === 'pass') {
      const currentQuantity = prototypeValues.quantity || 1;
      prototypeForm.resetFields(['part', 'defect']); // Reset part and defect
      prototypeForm.setFieldsValue({ quantity: currentQuantity });
      setPrototypeValues({ ...prototypeValues, quantity: currentQuantity });
      setHasSaved(false);
      setIsPartFilled(false);
      setIsFormFullyComplete(false);
    }
  };

  const handleRemoveItem = (index) => {
    setDisplayedDataList(prev => {
      const newList = prev.filter((_, i) => i !== index);
      return newList;
    });
    if (displayedDataList.length === 1) {
      setHasSaved(false);
    }
  };

  const handleClearFromPrototype = () => {
    console.log("Clear called from SelectPrototype");
    setIsPartFilled(false);
    setHasSaved(false);
    setDisplayedDataList([]);
    prototypeForm.resetFields();
    setPrototypeValues({ quantity: 1 });
    setIsFormFullyComplete(false);
  };

  const isLineItemSelected = !!selectedValue;

  const renderSelectedLineItem = () => {
    if (!selectedValue) {
      return <Typography.Text>Select a line and item to begin</Typography.Text>;
    }
    return <SeletedLineItem selectedValue={selectedValue} />;
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {renderSelectedLineItem()}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Button size="large" type="text">
            UserName: {userData?.data?.username || "N/A"}
          </Button>
          <Button size="large" type="primary" onClick={showModal}>
            Select Line & Item
          </Button>
        </div>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <Modal
        title="Select Line and Item"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', minHeight: '40px', padding: '10px', width: '100%' }}>
            <Button style={{ marginRight: '10px' }} onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleOk}>
              Submit
            </Button>
          </div>
        )}
      >
        <SelectModal form={form} />
      </Modal>

      <ResultTodayCounts getCounts={getTodayCount} />

      <Row style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start', paddingTop: '25px', gap: '20px', width: '100%' }}>
        <Col style={{ flex: '0 1 auto' }}>
          <ImageContainer
            front_image={eolData.front_image}
            back_image={eolData.back_image}
            onImageTypeChange={handleImageTypeChange}
          />
        </Col>
        <Col style={{ flex: '1 1 1', paddingLeft: '10px' }}>
          <SelectPrototype
            prototypeForm={prototypeForm}
            parts={eolData.parts}
            defects={eolData.defects}
            onValuesChange={handlePrototypeChange}
            onSave={handleSave}
            imageType={imageType}
            onClear={handleClearFromPrototype}
          />
        </Col>
        <Col style={{ paddingLeft: '10px', width: '100%' }}>
          <ReviewButton
            prototypeForm={prototypeForm}
            modalData={form.getFieldsValue()}
            onAction={handleReviewAction}
            hasSaved={hasSaved}
            isFormComplete={!!prototypeForm.getFieldValue('part')}
            imageType={imageType}
            displayedDataList={displayedDataList}
            refreshCounts={refreshCounts}
            isLineItemSelected={isLineItemSelected}
            isPartFilled={isPartFilled}
            isFormFullyComplete={isFormFullyComplete}
          />
        </Col>
      </Row>

      {displayedDataList.length > 0 && (
        <div style={{ padding: '10px', border: '1px solid #d9d9d9' }}>
          <Typography.Title level={4} style={{ marginTop: 0, marginBottom: '8px' }}>
            Defects
          </Typography.Title>
          {displayedDataList.map((data, index) => (
            <Row
              key={index}
              gutter={[16, 16]}
              style={{ marginBottom: '8px', alignItems: 'center' }}
            >
              <Col flex="120px">
                <Tag
                  color={data.imageType === 'Front' ? 'green' : 'blue'}
                  style={{
                    height: '35px',
                    width: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    transition: 'opacity 0.3s ease-in-out',
                    marginLeft: '10px',
                  }}
                >
                  Type: {data.imageType}
                </Tag>
              </Col>
              <Col flex="1" style={{ minWidth: 0 }}>
                <strong>Part:</strong> {data.partName}
              </Col>
              <Col flex="1" style={{ minWidth: 0 }}>
                <strong>Defect:</strong> {data.defectName}
              </Col>
              <Col flex="1" style={{ minWidth: 0 }}>
                <strong>NOS:</strong> {data.nos}
              </Col>
              <Col flex="120px">
                <Button
                  size="small"
                  type="danger"
                  onClick={() => handleRemoveItem(index)}
                  style={{ marginLeft: '10px', background: '#ef9a9a' }}
                >
                  <Trash2 size={16} />
                </Button>
              </Col>
            </Row>
          ))}
        </div>
      )}
    </>
  );
};

export default EOLC_DashbordPage;